export enum MimeType {
  APPLICATION_DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  APPLICATION_PDF = 'application/pdf',
  TEXT_PLAIN = 'text/plain'
}
